import { render, staticRenderFns } from "./LogoutView.vue?vue&type=template&id=d9c3bb64&scoped=true&"
import script from "./LogoutView.vue?vue&type=script&lang=ts&"
export * from "./LogoutView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c3bb64",
  null
  
)

export default component.exports